import { render, staticRenderFns } from "./StudyList.vue?vue&type=template&id=0bf7867d&scoped=true&lang=pug"
import script from "./StudyList.vue?vue&type=script&lang=ts"
export * from "./StudyList.vue?vue&type=script&lang=ts"
import style0 from "./StudyList.vue?vue&type=style&index=0&id=0bf7867d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7867d",
  null
  
)

export default component.exports